module.exports = __webpack_public_path__ + "b3709da68596230c81967790ab63ce24.pdf";